import {post,get} from '../../libs/ajax.js'

// 获取日报任务列表搜索条件的模板列表
export const getRecordSearchTemplateOptions = (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return get('/daily_task/template/getSearchTemplateList', data, options)
}

// 账户/产品搜索下拉框
export const getTemplateSelecOptions = (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return get('/daily_task/search_list', data, options)
}

// 任务生成记录列表
export const getTemplateRecordList = (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return get('/daily_task_record/list', data, options)
}

// 日报任务记录获取生成状态  轮循用  记录列表
export const getTemplateRecordLisItems = (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return get('/daily_task/getSendStatus', data, options)
}


// 任务明细列表

export const getTemplateRecordInfoList = (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return get('/daily_task_detail_record/list', data, options)
}
// 任务明细列表  轮循用  记录列表
export const getTemplateRecordInfoListItems = (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return get('/daily_task_record/getGenerateStatus', data, options)
}
// 创建模板提交
// export const postTemplateCreate = (data, options) => {
//     return post('/daily_task/template/create', data, options)
// }

// 任务生成记录列表下载前效验
export const getTemplateRecordListDown = (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return get('/daily_task_record/downloadCheck', data, options)
}
// 任务明细/任务详情列表下载前校验能否下载
export const getTemplateRecordInfoListDown = (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return get('/daily_task_detail_record/downloadCheck', data, options)
}

// 日报任务生成记录发送预览
export const getTemplateRecordEmail = (data, options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return get('/daily_task_record_email/get', data, options)
}
// 日报任务生成记录发送
export const getTemplateRecordEmailSend = (data,options) => {
    options = Object.assign({},options||{},{
        headers:{
            "Accept-Language":'en',
        },
    });
    return post('/daily_task_record_email/send', data, options);
}
